import React from 'react';

const DoctorDetailsModal = ({ doctor, onClose }) => {
  if (!doctor) return null;

  // Format ID to show last 8 characters in uppercase
  const formatId = (id) => {
    return id ? id.slice(-8).toUpperCase() : '-';
  };

  // Helper to safely get specialty name
  const getSpecialtyName = (specialty) => {
    if (!specialty) return 'N/A';
    return typeof specialty === 'object' ? specialty.name : specialty;
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
      <div className="relative bg-white rounded-lg shadow-xl max-w-lg mx-auto p-6 w-full">
        <div className="flex justify-between items-start pb-4 border-b mb-4">
          <h3 className="text-xl font-bold text-gray-800">Doctor Details</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <p className="text-sm text-gray-500">ID</p>
            <p className="text-md text-gray-800">{formatId(doctor._id)}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Name</p>
            <p className="text-md text-gray-800">{doctor.name}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Specialty</p>
            <p className="text-md text-gray-800">{getSpecialtyName(doctor.specialty)}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Qualification</p>
            <p className="text-md text-gray-800">{doctor.qualification}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Experience</p>
            <p className="text-md text-gray-800">{doctor.experience} years</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Fees</p>
            <p className="text-md text-gray-800">${doctor.fees}</p>
          </div>
          {doctor.bio && (
            <div>
              <p className="text-sm text-gray-500">Bio</p>
              <p className="text-md text-gray-800">{doctor.bio}</p>
            </div>
          )}
          {doctor.availability && (
            <div>
              <p className="text-sm text-gray-500">Availability</p>
              {Array.isArray(doctor.availability) ? (
                <div className="space-y-2">
                  {doctor.availability.map((slot, index) => (
                    <div key={slot._id || index} className="text-md text-gray-800 bg-gray-50 p-2 rounded">
                      <p>Day: {slot.day}</p>
                      <p>Hours: {slot.startTime} - {slot.endTime}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-md text-gray-800 bg-gray-50 p-2 rounded">
                  <p>Day: {doctor.availability.day}</p>
                  <p>Hours: {doctor.availability.startTime} - {doctor.availability.endTime}</p>
                </div>
              )}
            </div>
          )}
        </div>
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoctorDetailsModal;
